(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MailingTagService', MailingTagService);

  MailingTagService.$inject = ['$resource'];

  function MailingTagService ($resource) {
    return $resource(apiUrl + '/mailing/tags/file/:id', { id: '@id' }, {
      listTags: {
        url: apiUrl + '/mailing/tags/file/get-all',
        method: 'GET',
        params: {}
      },
      create: {
        method: 'POST',
        params: {},
        isArray: false
      },
      update: {
        method: 'PATCH',
        params: {},
        isArray: false
      },
      delete: {
        method: 'DELETE',
        params: {},
        isArray: false
      }
    });
  }
})();
